!function(){"use strict";
/* @preserve
   * https://github.com/Elkfox/Ajaxinate
   * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
   * MIT License (do not remove above copyright!)
   */function e(e){const t=e||{};this.settings=Object.assign({method:"scroll",container:"#AjaxinateContainer",pagination:"#AjaxinatePagination",offset:0,loadingText:"Loading",callback:null},t),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.preventMultipleClicks=this.preventMultipleClicks.bind(this),this.removeClickListener=this.removeClickListener.bind(this),this.removeScrollListener=this.removeScrollListener.bind(this),this.removePaginationElement=this.removePaginationElement.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()}e.prototype.initialize=function(){if(!this.containerElement)return;({click:this.addClickListener,scroll:this.addScrollListeners})[this.settings.method]()},e.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},e.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,void 0!==this.nextPageLinkElement&&null!==this.nextPageLinkElement&&this.nextPageLinkElement.addEventListener("click",this.preventMultipleClicks))},e.prototype.preventMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerText=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},e.prototype.checkIfPaginationInView=function(){const e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,t=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&t>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerText=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},e.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(!this.request.responseXML)return;if(4===!this.request.readyState||200===!this.request.status)return;const e=this.request.responseXML.querySelectorAll(this.settings.container)[0],t=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",e.innerHTML),void 0===t?this.removePaginationElement():(this.paginationElement.innerHTML=t.innerHTML,this.settings.callback&&"function"==typeof this.settings.callback&&this.settings.callback(this.request.responseXML),this.initialize())}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},e.prototype.removeClickListener=function(){this.nextPageLinkElement.removeEventListener("click",this.preventMultipleClicks)},e.prototype.removePaginationElement=function(){this.paginationElement.innerHTML="",this.destroy()},e.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},e.prototype.destroy=function(){return{click:this.removeClickListener,scroll:this.removeScrollListener}[this.settings.method](),this},customElements.get("ajaxinate-items")||customElements.define("ajaxinate-items",class extends HTMLElement{constructor(){super()}connectedCallback(){this.init()}

  /*
   * ------------------------------------------------------------------
   * Soi customisation
   *
   * Broadcast only exposes one pagination choice (theme setting
   * "enable_infinity_scroll"): numbered links when off, auto scroll-loading
   * when on. There is no "Show more" button option anywhere in the theme.
   *
   * The bundled Ajaxinate library already supports method:"click" (a real
   * load-more button, with loadingText and preventMultipleClicks) -- the theme
   * simply never passed it. This custom element now defaults to "click" and
   * turns the theme's screen-reader-only "Next" anchor into a visible button.
   *
   * Notes:
   * - sections/collection.liquid is the ONLY consumer of this script in the
   *   whole theme, so changing the default here affects nothing else.
   * - decorate() also runs as Ajaxinate's `callback`, which fires after each
   *   successful load. That matters: the library replaces the pagination
   *   element's innerHTML with the next page's markup, so without re-running
   *   decorate() the button would revert to the invisible anchor after the
   *   first click.
   * - The theme styles .pagination__loading as a fixed 150x150 box, sized for
   *   the scroll-mode spinner. Left alone that box sits at the left edge of the
   *   full-width pagination container, so the button appeared bottom-left with a
   *   large gap under the count line. decorate() collapses the box to auto
   *   height and full width so the button centres properly.
   * - The standalone spinner is hidden: in scroll mode it was the only visible
   *   loading indicator, but with a click button the label itself changes to
   *   loadingText, so the spinner is redundant and rendered as a stray mark
   *   above the button.
   * - The anchor's label is replaced by loadingText while a page is fetching;
   *   decorate() restores it afterwards.
   * - Set data-ajaxinate-method="scroll" on the element to get the old
   *   auto-scroll behaviour back.
   *
   * Still requires the theme setting "Enable infinity scroll" to be ON --
   * that is what makes the theme render this element at all.
   * ------------------------------------------------------------------
   */
  init(){
    this.endlessScroll=null;

    const id=this?.dataset.ajaxinateId,
          container=`#AjaxinateLoop[data-ajaxinate-id="${id}"]`,
          pagination=`#AjaxinatePagination[data-ajaxinate-id="${id}"]`;

    if(!(this?.children.length>0))return;

    const method=this.dataset.ajaxinateMethod||"click";

    const isDanish=(document.documentElement.getAttribute("lang")||"").toLowerCase().indexOf("da")===0;
    const labels=isDanish
      ?{more:"Vis flere",loading:"Indlæser …"}
      :{more:"Show more",loading:"Loading …"};

    const decorate=()=>{
      if(method!=="click")return;
      const pag=document.querySelector(pagination);
      if(!pag)return;
      const link=pag.querySelector("a");
      if(!link)return;

      link.textContent=labels.more;
      link.classList.add("btn","btn--secondary","btn--solid");
      link.setAttribute("aria-label",labels.more);

      const wrap=link.closest(".pagination__loading")||pag;
      wrap.style.display="flex";
      wrap.style.justifyContent="center";
      wrap.style.alignItems="center";
      wrap.style.width="100%";
      wrap.style.height="auto";
      wrap.style.minHeight="0";
      wrap.style.margin="0";
      wrap.style.padding="0";

      const loader=wrap.querySelector(".btn__loader");
      if(loader)loader.style.display="none";
    };

    decorate();

    this.endlessScroll=new e({
      container:container,
      pagination:pagination,
      method:method,
      loadingText:labels.loading,
      callback:decorate
    });
  }

  reinit(){this.unload(),this.init()}unload(){null!==this.endlessScroll&&(this.endlessScroll.settings.method="scroll",this.endlessScroll.destroy(),this.endlessScroll=null)}disconnectedCallback(){this.unload()}})}();
